import { combineReducers } from 'redux';

import {
  setOpenImageInstructionModal,
  setImageInstructionId,
  setInlineImageInstruction,
} from '../../actions';
import { ScriptEditorAction, ImageInstructionState } from '../../types';
import { Reducer } from '../../../../types';
import images from './images';

type ReducerOf<T extends keyof ImageInstructionState> = Reducer<ImageInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenImageInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setImageInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};
const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineImageInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
  images,
});
